import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './index.scss'

class OAuthButton extends React.Component {
  handleSignIn() {
    if (this.props.isReady) {
      this.props.onSignIn()
    }
  }
  render() {
    return (
      <div
        className={cn(
          'oauth-button-comp',
          { 'not-ready': !this.props.isReady },
          { 'with-border': this.props.hasBorder },
        )}
        onClick={() => this.handleSignIn()}
      >
        {this.props.children}
      </div>
    )
  }
}

OAuthButton.propTypes = {
  onSignIn: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isReady: PropTypes.bool.isRequired,
  hasBorder: PropTypes.bool,
}

export default OAuthButton
